import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate, getStatusClass } from '../../lib/utils';
import { Plus, Download, RefreshCw, XCircle } from 'lucide-react';

export default function AdminDeclarations({ 
  declarations, 
  onOpenCertModal,
  onDownloadPdf,
  onRenew,
  onRevoke 
}) {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Declarations
        </h2>
        <Button onClick={onOpenCertModal} className="btn-primary rounded-none" data-testid="issue-cert-btn">
          <Plus className="w-4 h-4 mr-2" />
          Issue Declaration
        </Button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Declaration ID</th>
              <th>Organization</th>
              <th>Standard</th>
              <th>Issue Date</th>
              <th>Expiry Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {declarations.map(cert => (
              <tr key={cert.id}>
                <td className="cert-id">{cert.declaration_id}</td>
                <td>{cert.org_name}</td>
                <td>{cert.standard_title}</td>
                <td>{formatDate(cert.issue_date)}</td>
                <td>{formatDate(cert.expiry_date)}</td>
                <td>
                  <Badge variant="outline" className={`rounded-none ${getStatusClass(cert.status)}`}>
                    {cert.status}
                  </Badge>
                </td>
                <td className="space-x-1">
                  <Button variant="ghost" size="sm" onClick={() => onDownloadPdf(cert.id, cert.declaration_id)} title="Download PDF" data-testid={`download-cert-${cert.id}`}>
                    <Download className="w-4 h-4" />
                  </Button>
                  {cert.status === 'active' && (
                    <>
                      <Button variant="ghost" size="sm" onClick={() => onRenew(cert.id)} title="Renew" data-testid={`renew-cert-${cert.id}`}>
                        <RefreshCw className="w-4 h-4" />
                      </Button>
                      <Button variant="ghost" size="sm" onClick={() => onRevoke(cert)} title="Revoke" className="text-red-600" data-testid={`revoke-cert-${cert.id}`}>
                        <XCircle className="w-4 h-4" />
                      </Button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
